import FlameIcon from '@repo/ui/src/components/Icons/FlameIcon';

interface EffortRatingProps {
  complexity: number;
  iconWidth?: string;
  effortText?: string;
  outOfText?: string;
}

const EffortRating = ({ complexity, iconWidth, effortText, outOfText }: EffortRatingProps) => (
  <span
    role="img"
    aria-label={`${effortText || 'Effort'}: ${complexity} ${outOfText || 'out of'} 5`}
    className="tw-flex tw-justify-center"
  >
    {[1, 2, 3, 4, 5].map((i) => (
      <FlameIcon key={i} outline={i > complexity} width={iconWidth} aria-hidden />
    ))}
  </span>
);

export default EffortRating;